module.exports = __webpack_public_path__ + "media/promo/lum2021/images/3bg-d5275073596b35c575e8e2f1b03ab9f9.jpg";